import { Link, NavLink } from "react-router-dom";
import SideBarLink from "./SideBarLink";
import { Dashboardsvg, Enquirysvg, Userssvg, Templatesvg, Adminsvg, Watersvg, Catchsvg, Rulessvg, Trophy, Archivesvg, Newslettersvg, QuickMessagesvg } from "../SvgFile/Index";
import { useEffect, useState } from "react";
import Logout from "../Component/Pages/Auth/Logout";

export default function Sidebar() {
  const [open, setOpen] = useState(false);
  const [links, setlinks] = useState([]);


  const user = JSON.parse(localStorage.getItem("userData"));

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    let links = [
      {
        url: "/admin/member",
        roleName: "Member Management",
        icon: <Userssvg />,
      },
      {
        url: "/admin/quick-message",
        roleName: "Quick Messages",
        icon: <QuickMessagesvg />,
      },
      {
        url: "/admin/enquiries",
        roleName: "GGC Enquiries",
        icon: <Enquirysvg />,
      },
      {
        url: "/admin/templates",
        roleName: "Manage Templates",
        icon: <Templatesvg />,
      },
      {
        url: "/admin/fishery-management",
        roleName: "Fishery Management",
        icon: <Watersvg />,
      },
      {
        url: "/admin/catch-return",
        roleName: "Catch Returns",
        icon: <Catchsvg />,
      },
      {
        url: "/admin/rules-and-regulations",
        roleName: "Rules And Regulations",
        icon: <Rulessvg />,
      },
      {
        url: "/admin/incident-reports",
        roleName: "Incident Reports",
        icon: <Rulessvg />,
      },
      {
        url: "/admin/annual-Competitions",
        roleName: "Annual Competition",
        icon: <Trophy />,
      },
      {
        url: "/admin/club-archive",
        roleName: "Club Archive",
        icon: <Archivesvg />,
      },
      {
        url: "/admin/news-letter",
        roleName: "News Letter",
        icon: <Newslettersvg />,
      },
      {
        url: "/admin/terms-and-conditions",
        roleName: "Tearms & Conditions",
        icon: <Newslettersvg />,
      }
    ];

    if (user?.role === "master_admin") {
      links.unshift({
        url: "/admin/subadmin",
        roleName: "Manage Admin Users",
        icon: <Adminsvg />,
      });
    }

    setlinks(links);

    // eslint-disable-next-line
  }, []);



  return (
    <>
      <div className="intersight_menu">
        <div className="top_menu">
          <div className="brand">
            <div className="dropdown">
              <button
                className="border-0 w-100 d-flex align-items-center"
                type="button"
              >
                <span className="d-flex align-items-center justify-content-center">
                  <img src="/image/fish.svg" alt="" srcSet="" className="img-fluid" />
                </span>
                <div className="brand_dashboard">
                  <span>Glendale Grayling Club</span>
                  <h6>Est. 1838</h6>
                </div>
              </button>
            </div>
          </div>

          <div className={`intersight_home`}>
            <div className="menu_div">
              <ul>
                <li>
                  <NavLink
                    to="/admin/dashboard"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span>
                      <Dashboardsvg />
                    </span>
                    Dashboard
                  </NavLink>
                </li>

                <li className="without_label">Workspace</li>
              </ul>
              <ul className="menu_scrollbar">
                {links?.map((item, i) => (
                  <SideBarLink
                    key={i}
                    href={item?.url}
                    name={item.roleName}
                    icon={item.icon}
                  />
                ))}
              </ul>
              <div className="bottom_menu">
                <p>
                  <Link
                    to="#"
                    className="d-block text-decoration-underline"
                  ></Link>
                </p>
                <div className="user_person">
                  <div className="dropdown">
                    <button
                      className="dropdown-toggle border-0 w-100 d-flex align-items-center p-0"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span className="d-flex align-items-center justify-content-center person_icon">
                        <img src={"/image/person.svg"} alt="" loading="lazy" className="img-fluid" />
                      </span>
                      <label className="person_name">
                        {user?.firstName} {user?.surname}
                        <span className="d-block">{user?.role
                          ? user.role
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase())
                          : ""}&nbsp;</span>
                      </label>
                    </button>
                    <ul className="dropdown-menu w-100">
                      <li>
                        <Link className="dropdown-item" to="/admin/profile">
                          Profile Info
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/admin/chnage-password">
                          Reset Password
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="#"
                          onClick={() => setOpen(true)}
                        >
                          Logout
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Logout open={open} handleClose={handleClose} />
    </>
  );
}
